var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 24,
    viewBox: "0 0 17 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.50235,
    cy: 8.17154,
    r: 5.72012,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.50213 0C3.88517 0 0.142578 3.73851 0.142578 8.35546C0.142578 12.9724 8.50213 24 8.50213 24C8.50213 24 16.8576 12.9724 16.8576 8.35546C16.8576 3.73851 13.1191 0 8.50213 0ZM8.50213 13.8876C5.44595 13.8876 2.96995 11.4116 2.96995 8.35546C2.96995 5.29929 5.44595 2.82329 8.50213 2.82329C11.5583 2.82329 14.0343 5.29929 14.0343 8.35546C14.0343 11.4116 11.5583 13.8876 8.50213 13.8876Z",
    fill: "#E82327"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.9e2462e9348f5ee95a138a6d7721d8e9.svg";
export { ForwardRef as ReactComponent };